<script lang="ts">
  import { getModalStore } from '@skeletonlabs/skeleton';
  import Button from '$lib/components/common/button/Button.svelte';

  const modalStore = getModalStore();

  const items: string[] = $modalStore[0]?.meta?.items ?? [];
  const title: string = $modalStore[0]?.meta?.title ?? 'Delete Details';
  const fileName: string = $modalStore[0]?.meta?.fileName ?? 'delete-details.txt';
  const error: string | undefined = $modalStore[0]?.meta?.error;
  const downloadLabel: string = $modalStore[0]?.meta?.downloadLabel ?? 'Download';

  function handleClose() {
    const response = $modalStore[0]?.response;
    if (response) {
      response(true);
    }
    modalStore.close();
  }

  function handleDownload() {
    const content = items.join('\r\n');
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    URL.revokeObjectURL(url);
  }
</script>

<div class="card w-modal max-w-2xl space-y-4 p-6" data-testid="modal" role="dialog" aria-modal="true">
  <header class="flex items-center justify-between">
    <h3 class="text-lg font-bold">{title}</h3>
  </header>

  {#if error}
    <div class="rounded-lg border border-error-500 bg-error-100 p-4 text-sm text-error-700">
      <p class="font-medium">An error occurred while processing an item:</p>
      <p class="mt-1">{error}</p>
    </div>
  {/if}

  <section class="max-h-96 overflow-auto rounded-lg border bg-gray-50 p-4">
    {#if items.length}
      <ul class="list-disc space-y-1 pl-5 text-sm text-gray-800">
        {#each items as item}
          <li>{item}</li>
        {/each}
      </ul>
    {:else}
      <p class="text-sm text-gray-600">No delete details are available for this client.</p>
    {/if}
  </section>

  <footer class="flex justify-end gap-3">
    <Button label={downloadLabel} colour="primary" size="medium" onClick={handleDownload} disabled={!items.length} />
    <Button label="Close" colour="secondary" size="medium" onClick={handleClose} />
  </footer>
</div>
